import { Box, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from '../../../../store'
import { setMobileTabIndex, setTabIndex } from '../../../../store/company/company.slice'
import SettingsSelectionListItem from './settings-selection-list-item/settings-selection-list-item.component'
import { settingsSelectionList } from './settings-selection-list.constants'

const SettingsSelectionList = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const index = useSelector((state: RootState) => state.company.tabIndex)

  const handleIndex = (nextIndex: number) => {
    dispatch(setTabIndex({ index: nextIndex }))
    dispatch(setMobileTabIndex({ index: nextIndex }))
  }

  const handleDeleteAccount = () => {
    navigate('/webdelete')
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {settingsSelectionList.map((item) => (
        <SettingsSelectionListItem
          key={item.id}
          index={index}
          handleIndex={handleIndex}
          {...item}
        />
      ))}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 'auto', pt: 2 }}>
        <Button
          variant='contained'
          color='error'
          size='small'
          onClick={handleDeleteAccount}
          sx={{
            textTransform: 'none',
            borderRadius: '8px',
            px: 2.5,
            py: 0.8,
            fontSize: '0.85rem',
            fontWeight: 600,
          }}
        >
          Delete Account
        </Button>
      </Box>
    </Box>
  )
}

export default SettingsSelectionList
